import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: '代理店情報',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  listed: true,
  rolesOnly: ['FCChina'],
  order: 0,
};
